import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../../http.service';
import { Router } from  '@angular/router';
import { DatePipe } from '@angular/common';
import { ShareddataService } from '../../../shareddata.service';
import { NotificationService } from '../../../notification.service';
import { NgEventBus } from 'ng-event-bus';

declare var $: any;

import { icon, latLng, marker, polyline, tileLayer } from 'leaflet';
@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.css'],
  providers: [DatePipe]

})
export class LocationsComponent implements OnInit {
	
	constructor(private _http: HttpService ,private datePipe : DatePipe,
	private sharedService: ShareddataService,public router: Router,
	private notifyService : NotificationService,
	private eventBus: NgEventBus

	) { }
	is_tip :any ="0";
	selected_tip_type : any='';	
	tip_amount : any='';	
	selected_tip_percentage : any='';	
	dFeeErrorMessage : String='';	
	selectedOrderService : String='';	
	userLoginData : any=[];	
	noStoreFoundMessage : String='';	
	res_name : String='';	
	loyalityrewarderror : String='';	
	currentTime: Date | undefined = new Date();
	francaisList : any;
	francaisTax : any=[];
	logoImage='assets/img/logo.png';
	selectedFrancais : any=0;
	selectedFrancaisData : any=[];
	cartModelData:any=[];
	deliveryamount: any = 0
	subtotalcart: any = 0
	loyalty_reward: any = 0.00
	loyalty_reward_api: any = 0.00
	loyalty_reward_msg: any = 'Will you be using a Loyalty card today?'
	loyalty_apply: any = '0'
	grandTotalwithTax: any = 0
	grandTotalwithTaxTemp: any = 0
	discountAmount: any = 0
	enable_factor4: any ='0'
	dfee: any = 0
	restaurantData : any =[];
	promoCodeData : any =[];
	getCouponList : any =[];

	is_surcharge_enabled='0';
	surcharge_amount='';
	surcharge_label='';
	discountApplyAlert=0;
	myCartDateTime: any;
	mytime: any = new Date();
	currentPage :any = '';
	url_store_id:any='';
	showCompleteOrderButton:any='0';
	serverCalucation:any='0';
	
	ngOnInit(): void {
	//Reseting the loyality on land page
	localStorage.removeItem('account_number');
	localStorage.removeItem('loyalityrewardamount');
	localStorage.removeItem('loyalty_pin');
	localStorage.removeItem('loyalityapply');
	
	setTimeout(function() {
			$('body').removeClass('cart-open');
			$('html').css('overflow','auto');
	}, 500);
	
	this.orderDateTime();
	this.sharedService.sharedOrderDateTime.subscribe((response: any) => {
		this.orderDateTime();
	});		
	
	this.userLoginData=JSON.parse(localStorage.getItem('user_detail'));
	
	this.res_name=localStorage.getItem('res_name');
	this.selectedOrderService=localStorage.getItem('selectedOrderService');
	this.getFrancaisList();
	this.logoImage=localStorage.getItem('logoImage');
	if(localStorage.getItem('francais_id')!=null){
		this.selectedFrancais=parseInt(localStorage.getItem('francais_id'));
		this.getFrancaisTaxCalulcation(this.selectedFrancais);

	}
	
	this.restaurantData=JSON.parse(localStorage.getItem('restaurant'));
	this.serverCalApiCall();

	this.eventBus.on('error:delivery').subscribe((meta:any) => {
		this.selectedOrderService = '';
    });
	this.currentPage ="location"; 
	
	this.eventBus.on('server:cal').subscribe((meta:any) => {
		if (this.currentPage ==="location") {
			this.serverCalApiCall();
			this.getFrancaisList();
		}
	});
	
	this.url_store_id = localStorage.getItem("url_store_id");
	if(localStorage.getItem('restaurant')!=null) {
		var restaurantlocal = JSON.parse(localStorage.getItem('restaurant'));
		this.enable_factor4 =  restaurantlocal.enable_factor4;
		this.checkingloyalityreward();
		
	}
	
  }
	ngOnDestroy() {
	   this.currentPage = "";
	}
    serverCalApiCall () {
		this.subtotalcart=this.getTotalCartAmount();
		this.grandTotalwithTax=this.getTotalCartAmount();
		this.grandTotalwithTaxTemp=this.getTotalCartAmount();
		
		this.serverCalucation ="0";
		
		this.deliveryamount = 0.00;
		this.discountAmount = 0.00;
		var selectedOrderService=localStorage.getItem('selectedOrderService');
		this.selected_tip_percentage=localStorage.getItem('selected_tip_percentage');
		if (this.selected_tip_percentage!=null && this.selected_tip_percentage!='no' && this.selected_tip_percentage!='30' && this.selected_tip_percentage!='25' && this.selected_tip_percentage!='20') {
			this.selected_tip_type ="custom";
			$('.tip-custom-input').val(this.selected_tip_percentage);
		} else {
			this.selected_tip_type ="";
			$('.tip-custom-input').val('');
		}
		var promoData = JSON.parse(localStorage.getItem('promoData'));
		var isPromoApplied=localStorage.getItem('isPromoApplied');
		
		var iscouponApplied=localStorage.getItem('iscouponApplied');
		let couponData=JSON.parse(localStorage.getItem('couponData'));
		
		const server_cal_object = new FormData();

		server_cal_object.append( 'res_id', '49');
		server_cal_object.append( 'subtotal', this.subtotalcart);
		
		if (this.selectedFrancais>0) {
			server_cal_object.append( 'franchise_id', this.selectedFrancais);
		}
		if (this.selected_tip_percentage>0) {
			server_cal_object.append( 'selected_tip_percentage', this.selected_tip_percentage);
		}
		
		if (iscouponApplied!=null && iscouponApplied==='1' && couponData!=null) {
			var couponId = couponData.id;
			server_cal_object.append( 'couponid', couponId);
		}
		
		if (isPromoApplied!=null && isPromoApplied==='1' && promoData!=null) {
			var promoid = promoData.id;
			server_cal_object.append( 'promoid', promoid);
		}
		
		server_cal_object.append( 'service_type', selectedOrderService);
		
		this._http.postRequest('server_side_taxcal.php',server_cal_object).subscribe((data: any) => {
			if (data.error_type) {
				if (data.error_type==='other') {
					this.notifyService.showError(data.message, "Error ..!!");
					localStorage.removeItem('promoData');
					localStorage.removeItem('isPromoApplied');
					localStorage.removeItem('iscouponApplied');
					localStorage.removeItem('couponData');
					this.serverCalApiCall();
					return false;
				}
			}
			if (data.data.totalamount) {
				this.grandTotalwithTax = data.data.totalamount-this.loyalty_reward;
			}
			if (data.data.taxesdata) {
				this.francaisTax = data.data.taxesdata;
			}
			if (data.data.discountamount) {
				this.discountAmount = data.data.discountamount;
			}
			if (data.data.tip_amount) {
				this.tip_amount = data.data.tip_amount;
			}
			if (data.data.deliveryamount) {
				this.deliveryamount = data.data.deliveryamount;
			}
			if (data.data.is_surcharge_enabled==="1") {
				this.is_surcharge_enabled=data.data.is_surcharge_enabled;
				this.surcharge_amount=data.data.surcharge_amount;
				this.surcharge_label=data.data.surcharge_label;
			} else {
				this.is_surcharge_enabled='0';
				this.surcharge_amount='';
				this.surcharge_label='';
			
			} 
			this.serverCalucation ="1";
			this.setTipButtonsAmount();
			$('.francais-selectbtn').prop('disabled', false);

		}); 
	}
	
	//Set the tip button amount 
	setTipButtonsAmount () {
		var getTotalForTip = this.grandTotalwithTax;
		if(this.tip_amount>=0) {
			getTotalForTip = getTotalForTip -this.tip_amount;
		}
		if (getTotalForTip>0) {
			var tip_20_per = getTotalForTip*20/100;
			var tip_25_per = getTotalForTip*25/100;
			var tip_30_per = getTotalForTip*30/100;
			$('#tip-20').html("20%<br>$"+tip_20_per.toFixed(2));
			$('#tip-25').html("25%<br>$"+tip_25_per.toFixed(2));
			$('#tip-30').html("30%<br>$"+tip_30_per.toFixed(2));
 		}
	}
	
	orderDateTime () {
		if(localStorage.getItem("orderDatetime")!=null){
			this.mytime=localStorage.getItem("orderDatetime");
			var orderTime = this.datePipe.transform(this.mytime, 'h:mm a');
			var orderDate = this.datePipe.transform(localStorage.getItem("orderDate"), 'EEEE, MMMM d');
			this.myCartDateTime=orderDate+' '+orderTime;
		}else{
			this.myCartDateTime=this.datePipe.transform(this.mytime, 'EEEE, MMMM d h:mm a');
		}
	}
	
  getFrancaisList()
  {
	this.noStoreFoundMessage='';
	var token=localStorage.getItem('jwt_token');
	var token=localStorage.getItem('jwt_token');
	var deliveryAddress=JSON.parse(localStorage.getItem('deliveryAddress'));
	var currenTime='';
	var currenDate='';
	if(localStorage.getItem('orderDatetime')!=null){
		currenTime=this.datePipe.transform(localStorage.getItem('orderDatetime'), 'H:mm');
		currenDate=this.datePipe.transform(localStorage.getItem('orderDatetime'), 'YYYY-M-d');
	}else{
		currenTime=this.datePipe.transform(this.currentTime, 'H:mm');
	}
	if (localStorage.getItem("orderDate")!=null) {
		currenDate=this.datePipe.transform(localStorage.getItem('orderDate'), 'yyyy-MM-dd');
	} else {
		currenDate=this.datePipe.transform(new Date(), 'yyyy-MM-dd');
	}
	var geoLocation='';
	if(deliveryAddress!=null && this.selectedOrderService==='Delivery'){
		 
		for(var i=0;i<deliveryAddress.length;i++) {
			if(deliveryAddress[i].lat && deliveryAddress[i].lat!='') {
				geoLocation+='&lat='+deliveryAddress[i].lat;
			}if(deliveryAddress[i].lng && deliveryAddress[i].lng!='') {
				geoLocation+='&lng='+deliveryAddress[i].lng;
			}
		}
		localStorage.removeItem('francais_id')
	} 
	
	this._http.getRequest('get_francaislist.php?res_id=49&user_current_hour='+currenTime+geoLocation+'&user_current_date='+currenDate,token).subscribe((data:any) => {
		if(data.data.francais_data){
			if (data.data.success==='0') {
				this.noStoreFoundMessage = data.data.message;
			}
			this.francaisList=data.data.francais_data;
			var match_url = 0;
			if (this.url_store_id>0) {
				for (var i=0;i<this.francaisList.length;i++) {
					if (this.francaisList[i].id == this.url_store_id && this.francaisList[i].is_open==='open') {
						this.selectedFrancaisData=this.francaisList[i].id;
						this.selectFrancais(this.francaisList[i].id, '');
						match_url = 1;
					}
				}
			}
			
			if (this.francaisList[0]  && localStorage.getItem('francais_id')===null && match_url==0) {

				if(this.francaisList[0].is_open==='open') {
					this.selectedFrancaisData=data.data.francais_data;
					this.selectFrancais(this.francaisList[0].id, '');
				}
			}
			
		} 
		
		}
	);
  }
  
  selectFrancais(id,event)
  {
	$('.francais-tick').remove();
	$('.francais-selectbtn').show();
	$('#francaisid_'+id).hide();
	this.selectedFrancais=id; 	
	localStorage.setItem('francais_id',id);	
	//this.serverCalApiCall();
	setTimeout(function(){ 
		$('.francais-selectbtn').prop('disabled', true);
	}, 100);

	

	this.getFrancaisTaxCalulcation(id);

  }
    getFrancaisTaxCalulcation(id){
	var token=localStorage.getItem('jwt_token');
	var currenTime='';
	if(localStorage.getItem('orderDatetime')!=null){
		currenTime=this.datePipe.transform(localStorage.getItem('orderDatetime'), 'H:mm');
	}else{
		currenTime=this.datePipe.transform(this.currentTime, 'H:mm');
	}
	var currenDate = "";
	if (localStorage.getItem("orderDate")!=null) {
		currenDate=this.datePipe.transform(localStorage.getItem('orderDate'), 'yyyy-MM-dd');
	} else {
		currenDate=this.datePipe.transform(new Date(), 'yyyy-MM-dd');
	}
	this._http.getRequest('get_franchise.php?franchise_id='+id+'&user_current_hour='+currenTime+'&user_current_date='+currenDate,token).subscribe((data:any) => {
		if(data.data.francais_data){
			if (data.data.francais_data[0].openclose==='open') {
				this.selectedFrancaisData=data.data.francais_data;
				if (this.selectedFrancaisData[0].is_tip==="0") {
					localStorage.removeItem('selected_tip_percentage');	
				}
				//is_tip
			} else {
				this.selectedFrancais=0; 	
				localStorage.removeItem('francais_id');	
			}
		}
		this.serverCalApiCall();

		}
	);  
  }
 
  roundCustomNumber(amount){
    return (Math.floor(amount * Math.pow(10, 2)) / Math.pow(10, 2)).toFixed(2);
  }
	getTotalCartAmount(){
		var orderData=localStorage.getItem('orderData');
		var total_amount=0;

		if(orderData!=null){
			this.cartModelData=JSON.parse(orderData);
			for (var i=0;i<this.cartModelData.length;i++){
				total_amount=total_amount+this.cartModelData[i].ItemAmt;
			}
		}
		return total_amount;		
	}
	
	checkForCoupon()
	{	this.discountApplyAlert=1;
		var user_detail=localStorage.getItem('user_detail');
		var userData=JSON.parse(user_detail);
		if(userData.id){
			const getCouponList = new FormData();
			getCouponList.append( 'user_id', userData.id);
			getCouponList.append( 'res_id', '49');
		
			if(this.selectedFrancais!=0 && this.selectedFrancais>0) {
				getCouponList.append('franchise_id', this.selectedFrancais.toString());
			}
			this._http.postRequest('getcouponlist.php',getCouponList).subscribe((reponse : any)=>{
				$('#couponListModal').modal('show');
				this.getCouponList=reponse.data;
			});
		}
	}
	applyCouponDiscount(coupon,$event) {
		localStorage.setItem('couponData', JSON.stringify(coupon));
		localStorage.setItem('iscouponApplied', '1');
		
		localStorage.removeItem('promoData');
		localStorage.removeItem('isPromoApplied');
		
		$('#couponListModal').modal('hide');

		this.serverCalApiCall ();
	}
	
	applyPromoCodeDiscountCal (promo, event) {
		localStorage.setItem('promoData', JSON.stringify(promo));
		localStorage.setItem('isPromoApplied', '1');
		
		localStorage.removeItem('couponData');
		localStorage.removeItem('iscouponApplied');
		this.serverCalApiCall ();
		$('#promoCodeListModal').modal('hide');

	}
	
	//Are used to apply the coupon from input filed 
	applyCoupon() {
		var user_detail=localStorage.getItem('user_detail');
		var userData=JSON.parse(user_detail);
		if(userData.id){
			var couponCode=$('#applyCoupen').val();
			if(couponCode==='') {
				alert('Please enter the coupon code...!!');
				return false;
			}
			const getCouponList = new FormData();
			getCouponList.append( 'user_id', userData.id);
			getCouponList.append( 'res_id', '49');
			getCouponList.append( 'code', couponCode);
			if(this.selectedFrancais!=0 && this.selectedFrancais>0) {
				getCouponList.append('franchise_id', this.selectedFrancais.toString());
			}
			this._http.postRequest('getcoupon.php',getCouponList).subscribe((reponse : any)=>{
				if (reponse.status==='0') {
					alert(reponse.message);
				} else if (reponse.status==='1'){
					localStorage.setItem('couponData', JSON.stringify(reponse.data));
					localStorage.setItem('iscouponApplied', '1');
					
					localStorage.removeItem('promoData');
					localStorage.removeItem('isPromoApplied');
					this.serverCalApiCall();
				}
			});
		}
	}
	
	getPromoCodeList() {
		var userData=JSON.parse(localStorage.getItem('user_detail'));

		const getPromoCodeList = new FormData();
		getPromoCodeList.append( 'user_id', userData.id);
		getPromoCodeList.append( 'res_id', '49');
		if(this.selectedFrancais!=0 && this.selectedFrancais>0) {
			getPromoCodeList.append('franchise_id', this.selectedFrancais.toString());
		}
		getPromoCodeList.append('franchise_id', '30');

		this._http.postRequest('getpromocode.php?res_id=49',getPromoCodeList).subscribe((reponse : any)=>{
			if (reponse.status==='0') {
				alert('No Record found');
			} else if (reponse.status==='1'){
				this.promoCodeData = reponse.data;
				$('#promoCodeListModal').modal('show');
			}
		});
	}
	
	
	openSidebar () {
		$('.cart-dropdown-wrapper').click();
	}
	 cartItemDateTime(){
	var isvalid ='1';
	var orderData:any=localStorage.getItem('orderData');
	if(orderData!=null){
		orderData = JSON.parse(orderData);
		for (var i=0;i<orderData.length;i++) {
			
			const givenDate:any= new Date(orderData[i].date);
			const currentDate:any = new Date();
			
			const diffMs = currentDate - givenDate; // Difference in milliseconds
			const diffHours = diffMs / (1000 * 60 * 60); // Convert to hours
			const diffMinutes = diffMs / (1000 * 60); // Convert to minutes
			
			
			if (diffHours>4) {
			//if (diffMinutes>5) {
				alert("Order Timed Out - Order Lost, Please login and try again");
				localStorage.removeItem('isLogin');
				localStorage.removeItem('orderData');
				

				localStorage.removeItem('isLogin');
				localStorage.removeItem('user_detail');
				localStorage.removeItem('jwt_token');
				localStorage.removeItem('is_call');
				var root = this;
				isvalid ='0';
				setTimeout(() => {
				  this.router.navigateByUrl('/login');
				}, 500);
		
				//window.location.href='/login';
			}
			
		}
		
	}
	return isvalid;
  }
  
	redirectCheckout() {
		var cardItemsValid = this.cartItemDateTime();
		if (cardItemsValid=== '0') {
			return ;
		}
		
		if (this.serverCalucation==='1') {
			localStorage.setItem('location_to_checkout', '1');
			this.router.navigateByUrl('/checkout');
		}
	}
	
	applyTip (percentage) {
		if (percentage==='no') {
			localStorage.setItem('selected_tip_percentage', 'no');
			this.serverCalApiCall();
		}else if (percentage==='custom') {
			$('#tip-custom').modal('show');
		} else {
			localStorage.setItem('selected_tip_percentage', percentage);
		}
		
		setTimeout(() => {
		this.serverCalApiCall();
		}, 1000);
	}
	appCustomTip () {
		this.selected_tip_type = 'custom';	
		localStorage.setItem('selected_tip_percentage', $('.tip-custom-input').val());
		setTimeout(() => {
			this.serverCalApiCall();
		}, 1000);
	}
	
	loyalityreward ( type:any ) 
	{
		if (type==='yes') {
			$('#loyalityreward').modal('show');
		} else {
			$('#loyalityreward').modal('hide');
		}
	}
	
	loyalityrewardapply ( type:any ) 
	{
		this.loyalty_apply= '1';
		if (type==='yes') {
			
			this.loyalty_reward = this.loyalty_reward_api;
			if (this.loyalty_reward>=this.grandTotalwithTax) {
				this.showCompleteOrderButton = '1';
			}
			$('#loyalityreward-confirm').modal('hide');
			localStorage.setItem('loyalityrewardamount',this.loyalty_reward);
			localStorage.setItem('loyalityapply','1');
			
			this.serverCalApiCall();
		} else {
			localStorage.setItem('loyalityapply','0');

			$('#loyalityreward-confirm').modal('hide');
		}
		
	}
	
	verfiyAccount () 
	{
		var account_number = $('#account_number').val();
		var password_account = $('#password_account').val();
		if (account_number==='') {
			this.loyalityrewarderror='Please fill all the Account # fields first.';
			return ;
		}
		const factor4data = new FormData();
		factor4data.append('account_number', account_number);
		factor4data.append('password_account', password_account);
		$('#loyalityreward').modal('hide');
		
		localStorage.removeItem('account_number');
		localStorage.removeItem('loyalityrewardamount');
		localStorage.removeItem('loyalty_pin');
		localStorage.removeItem('loyalityapply');
		this.loyalty_reward_api = 0;
		
		this.showCompleteOrderButton = '0';
		this._http.postRequest('loyaltyredemption.php',factor4data).subscribe((reponse : any)=>{
			if (reponse.success==1) {
				

				if (reponse.amount>=1) {
					this.loyalty_reward_api = this.grandTotalwithTax;
					if (this.grandTotalwithTax>=reponse.amount) {
						this.loyalty_reward_api = reponse.amount;
					}
					
					$('#loyalityreward-confirm').modal('show');
					this.loyalty_reward_msg = "Thank you for using your loyalty card";
					localStorage.setItem('account_number', account_number);
					localStorage.setItem('loyalty_pin', password_account);
				
					$('#loyalityreward-conf-msg').html('Would you like to apply your Loyalty Dollars of $'+this.loyalty_reward_api+' to the order?');
				} else {
					this.loyalty_apply= '1';
					localStorage.setItem('account_number', account_number);
					localStorage.setItem('loyalty_pin', password_account);
					localStorage.setItem('loyalityapply', '0');
					this.loyalty_reward_msg = "Thank you for using your loyalty card";

					alert("No Loyalty rewards available yet");
				}
			} else if (reponse.success==0) {
				alert(reponse.message);
				this.loyalty_apply= '0';

			}
		});

	}
	
	checkingloyalityreward () {
		var account_number = localStorage.getItem('account_number');
		var loyalityrewardamount = localStorage.getItem('loyalityrewardamount');
		var loyalityapply = localStorage.getItem('loyalityapply');
		if (loyalityapply==='1' || loyalityapply==='0') {
			this.loyalty_apply= '1';
			this.loyalty_reward_msg = "Thank you for using your loyalty card";
		}
	
		
		if (loyalityapply==='1') {
			this.loyalty_reward = loyalityrewardamount;
			this.loyalty_reward_msg = "Thank you for using your loyalty card";
			if (this.loyalty_reward>=this.grandTotalwithTax) {
				this.showCompleteOrderButton = '1';
			}
			this.serverCalApiCall();
		}
	}
}


